import { forwardRef } from 'react';
import { TextFieldProps } from '@mui/material';

import { Root } from './input.styles';

export const Input = forwardRef<HTMLInputElement, TextFieldProps>(
	({ type = 'text', InputProps, className, ...props }, ref) => {
		return (
			<Root
				{...props}
				color="primary"
				type={type}
				variant="filled"
				InputProps={{
					disableUnderline: true,
				}}
				inputRef={ref}
			/>
		);
	}
);
